/* eslint-disable max-len */
import { SERVER_API } from 'PortalDir/constants/app/endpoints';

import { Files } from './models';

const staticUrl = `${SERVER_API}/static`;

const FILES: Files[] = [
  {
    title: 'Руководство пользователя КМНС', // Заголовок карточки  с файлом
    description: '', // Описание файла
    url: `${staticUrl}/docs/hmao/Руководство пользователя КМНС.pdf`, // Ссылка на загрузку файла
    icon: 'lightning-icon.png', // Иконка карточки
    file_type: 'pdf', // Тип файла
    file_size: '2.1', // Размер файла в Мб
  },
  {
    title: 'Жизненный цикл ПО ГИС КМНС', // Заголовок карточки  с файлом
    description: '', // Описание файла
    url: `${staticUrl}/docs/Жизненный цикл ПО ГИС КМНС.pdf`, // Ссылка на загрузку файла
    icon: 'star-icon.png', // Иконка карточки
    file_type: 'pdf', // Тип файла
    file_size: '0.4', // Размер файла в Мб
  },
  {
    title: 'Инструкция по установке экземпляра ПО',
    description: '',
    url: `${staticUrl}/docs/Инструкция по установке экземпляра ПО.pdf`,
    icon: 'pentagon-icon.png',
    file_type: 'pdf',
    file_size: '0.3',
  },
  {
    title: 'Описание функциональных характеристик ГИС КМНС',
    description: '',
    url: `${staticUrl}/docs/Описание функциональных характеристик ГИС КМНС.pdf`,
    icon: 'rhomb-icon.png',
    file_type: 'pdf',
    file_size: '0.9',
  },
  {
    title: 'Руководство администратора КМНС',
    description: '',
    url: `${staticUrl}/docs/hmao/Руководство администратора КМНС.pdf`,
    icon: 'pentagon-icon.png',
    file_type: 'pdf',
    file_size: '11.6',
  },
  {
    title: 'Стоимость автоматизированной информационной системы',
    description:
      'Определяется индивидуально для каждого заказчика в зависимости от его специфических потребностей и требований. Мы стремимся предложить максимально персонализированный подход, учитывая все ваши предпочтения и специфические условия работы.',
    url: '',
    icon: 'lightning-icon.png',
    file_type: '',
    file_size: '',
  },
];

export { FILES };
